import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Loader from "react-loader";
import {fetchedPage, loadPage} from "../../actions/page";
import Title from "../elements/Title";
import RegionSelect from "../elements/RegionSelect";
import RegionLoop from "../elements/RegionLoop";
import SideLoop from "../elements/SideLoop";
import Resources from "../elements/Resources";
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";
import HeroImage from "../elements/HeroImage";
class RegionPage extends React.Component {

    componentWillUnmount() {
        this.props.loadPage()
    }
    componentDidMount() {
        this.props.fetchedPage('/api' + this.props.location.pathname).then();
    }

    render() {
        const {page, modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={"region-page transition-item"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.title}/>
                  <div className={"container"}>
                      <div className={"row"}>
                          <div className={"col-md-8"}>
                              <RegionLoop/>
                          </div>
                          <div className={"col-md-4"}>
                              <Resources resources={page.resources}/>
                          </div>
                          <div className={"col-md-12"}>
                              <SideLoop/>
                          </div>
                      </div>
                  </div>
                  <RegionSelect title=''/>
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

RegionPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(RegionPage);




// WEBPACK FOOTER //
// ./src/components/pages/RegionPage.js